import { useEffect, useMemo } from 'react';
import { ICON_COLOR } from '@zep-us/zus/tokens';
import { useTranslation } from 'next-i18next';
import { logger } from '@zep/core-logger';
import { PlayIcon } from '@/icons';
import { ROUND_TEMPLATE_TYPE } from '@/shared/utils/answerRevealMode';
import { useBuildFormContext } from '../form/schema';
import { ToggleOptionContainer } from './ToggleOptionContainer';
export const ToggleAllowField = () => {
  const {
    watch,
    setValue
  } = useBuildFormContext();
  const isAllowPass = watch('isAllowPass');
  const templateType = watch('templateType');
  const {
    t
  } = useTranslation(['build']);
  const handleAllowPass = () => {
    const value = !isAllowPass;
    setValue('isAllowPass', value, {
      shouldTouch: true,
      shouldDirty: true
    });
    logger.track('incorrect_answers', {
      value
    });
  };
  const optionDisabled = useMemo(() => {
    return templateType === ROUND_TEMPLATE_TYPE;
  }, [templateType]);
  useEffect(() => {
    if (templateType === ROUND_TEMPLATE_TYPE) {
      setValue('isAllowPass', true, {
        shouldTouch: true,
        shouldDirty: true
      });
    }
  }, [templateType, setValue]);
  return <div className="flex flex-col gap-sm" data-sentry-component="ToggleAllowField" data-sentry-source-file="ToggleAllowFiled.tsx">
      <ToggleOptionContainer optionIcon={<PlayIcon size="sm" fill={optionDisabled ? ICON_COLOR.disabled : ICON_COLOR.neutral} />} optionTitle={t('build:allowPass.title')} optionDescription={t('build:allowPass.description')} isOn={isAllowPass} onToggle={handleAllowPass} planType="FREE" isBadgeVisible={false} disabled={templateType === ROUND_TEMPLATE_TYPE} data-sentry-element="ToggleOptionContainer" data-sentry-source-file="ToggleAllowFiled.tsx" />
    </div>;
};